import React from 'react';
import { useDemo } from '../providers/DemoProvider';
import './LockedFeatureModal.css';

const LockedFeatureModal: React.FC = () => {
  const { isLockedModalOpen, hideLockedModal } = useDemo();

  if (!isLockedModalOpen) {
    return null;
  }

  return (
    <div className="modal-overlay" onClick={hideLockedModal}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>Unlock the Full Overture Experience!</h2>
        <p>
          By joining the Overture after-school program, you'll unlock all of these amazing games and premium content!
        </p>
        <p>
          You'll also get to join a special club at your school where you can learn music, compose songs, and share your creativity with friends.
        </p>
        <a href="https://www.overture.games/find-my-program" target="_blank" rel="noopener noreferrer" className="modal-button">
          Find Your School's Music Club
        </a>
        <button onClick={hideLockedModal} className="modal-close-button">Maybe Later</button>
      </div>
    </div>
  );
};

export default LockedFeatureModal;
